package one.devsbox.www.ui.campaigns.detail

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.DisplayProvider
import one.devsbox.www.provider.LocalDisplayProvider
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class CampaignDCtx private constructor(
    val vm: CampaignDVM,
    val nav: Navigation,
    val args: ArgsId,
    val me: MeProvider,
    val dp: DisplayProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color,
    val colorErrorContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): CampaignDCtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(CampaignDVM::class)
            val me = LocalMeProvider.current
            val dp = LocalDisplayProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primaryContainer
            val colorSecondary = MaterialTheme.colorScheme.secondaryContainer
            val colorError = MaterialTheme.colorScheme.errorContainer
            return remember(args.id) {
                CampaignDCtx(
                    vm, nav, args, me, dp,
                    colorPrimary, colorSecondary, colorError
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
